import 'bootstrap/dist/css/bootstrap.css';
import * as bootstrap from 'bootstrap';
import $ from 'jquery';

window.bootstrap = bootstrap;

// Custom CSS imports
import '../css/site.css';

$(document).ready(function () {
    // Check if the password exists in localStorage and matches "loscontiquis18"
    if (localStorage.getItem('password') === "loscontiquis18") {
        $("#hide-panel").addClass("d-none");
    }

    $("#psw-btn").on("click", function () {
        let x = $("#psw").val();
        if (x === "loscontiquis18") {
            $("#hide-panel").addClass("d-none");
            localStorage.setItem('password', x);
        }

    });

    //auth register
    let otherMaterialId = $("#otherMaterialId").data('id');
    let materialSelect = $("#material-select");
    let materialField = $("#material-field");
    let otherField = $("#other-field");
    
    materialSelect.on("change", function () {
        console.log(otherMaterialId, materialSelect.val());
        if (materialSelect.val() === otherMaterialId) {
            otherField.removeClass("d-none");
            materialField.attr('required', 'required');
        } else {
            otherField.addClass("d-none");
            materialField.removeAttr('required');
        }
    });
});
